
import 'whatwg-fetch';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

import * as app from './app';
import * as core from './core';
import * as map from './map';
import * as multiscene from './multiscene';
import * as search from './search';

import init from './init';

const log = core.Log.getLogger('MultiSceneForApp.index');

if (process.env.NODE_ENV !== 'production') {
    core.Log.init('TRACE', {prefixName: true});
} else {
    core.Log.init('INFO', {prefixName: false});
}

log.info('MultiSceneForApp version ' + MSFA_VERSION_STRING);

initializeIcons();

export default {
    init,
    addEventListener: core.addEventListener,
    executeCommand: core.executeCommand,
    removeEventListener: core.removeEventListener,
    renderComponent: core.renderComponent,
    Log: core.Log,

    app,
    map,
    multiscene,
    search
}
